<template>
  <div class="modal-long-content">
    <EditForm
      :entities="entities"
      :counter="counter"
      :entity-data="entity"
      :payment-terms="paymentTerms"
      :on-success="handleSuccess"
      :on-cancel="handleFormCancel"
    />
  </div>
</template>

<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'
import EditForm from '@/Modules/Entity/Components/EditForm.vue'
import DatasetService from '@/Modules/Dataset/DatasetService.js'
import CounterService from '@/Modules/Counter/CounterService.js'
import EntityModel from '@/Modules/Entity/EntityModel.js'
import { settingKeys } from '@/Modules/Setting/SettingModel.js'
import EntityService from '../EntityService.js'

export default {
  name: 'CreateEntityModal',

  components: {
    EditForm,
  },

  mixins: [ModalMixin],

  props: {
    meta: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      entity: new EntityModel(
        this.meta.entity || { parentId: this.meta.parentId }
      ),
      entities: [],
      paymentTerms: [],
      counter: null,
      oldentities: [],
    }
  },

  created() {
    DatasetService.byTag('roles').then((roles) => {
      this.roles = roles
    })

    EntityService.listParent().then((entities) => {
      this.entities = entities.data.data.map((entity) => {
        return {
          label: entity.name,
          selected: false,
          value: entity.id,
        }
      })
    })

    DatasetService.byTag('scopedEntities').then((entities) => {
      this.oldentities = entities
    })
    DatasetService.byTag('paymentTerms').then((paymentTerms) => {
      this.paymentTerms = paymentTerms
    })
    const entityCounterId = this.getEntityCounterId()
    if (entityCounterId) {
      CounterService.show(entityCounterId)
        .then((counter) => {
          this.counter = counter
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },

  methods: {
    handleSuccess(entity) {
      this.onSuccess && this.onSuccess(entity)
      this.closeModal()
    },
    handleFormCancel() {
      this.closeModal()
    },
    getEntityCounterId() {
      return this.setting(settingKeys.entityCounterId)
    },
  },
}
</script>
<style scoped>
.card-body {
  overflow: hidden;
  width: 100%;
}
.modal-long-content {
  position: relative;
  max-height: 75vh;
  overflow-x: hidden;
  margin-right: -12px;
  padding-right: 12px;
}
</style>
